// Shared "embed a link" helpers — a pasted link becomes a small pill showing
// its site name (e.g. "canva.com") instead of a bare URL; clicking it opens
// the real link in a new tab. Used by:
//   - RichNotesEditor's dedicated Embedded Links section (task/event add/edit
//     modal + detail panels) — structured data, rendered as React.
//   - The Journal/Notes tab's own editor — inserted inline as HTML.
// No network call: the pill's label is derived straight from the URL itself.

export function isValidHttpUrl(str) {
  try {
    const u = new URL(String(str || "").trim());
    return u.protocol === "http:" || u.protocol === "https:";
  } catch {
    return false;
  }
}

// "https://www.canva.com/design/xyz" → "canva.com"
export function siteNameFromUrl(url) {
  try {
    return new URL(String(url || "").trim()).hostname.replace(/^www\./i, "");
  } catch {
    return String(url || "");
  }
}

function escapeHtml(str) {
  return String(str || "").replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
}

// Builds the pill HTML inserted into a contentEditable note (Journal tab).
// contenteditable="false" so it behaves as one atomic block, same as the
// checkbox rows — backspace deletes it whole instead of editing inside it.
// The wrapper is a block element (forcing its own line, so multiple embedded
// links stack instead of crowding side by side) but width:fit-content keeps
// its non-editable box no wider than the pill itself — otherwise a plain
// block div spans the full line and swallows clicks in the empty space
// beside the pill, making it impossible to place the caret there to type.
export function buildEmbedPillHtml(url) {
  if (!isValidHttpUrl(url)) return "";
  const href = escapeHtml(url.trim());
  const site = escapeHtml(siteNameFromUrl(url));
  return (
    `<div contenteditable="false" style="display:block;width:fit-content;margin:2px 0;">`
    + `<a href="${href}" target="_blank" rel="noopener noreferrer" class="cj-embed-pill" `
    + `style="display:inline-flex;align-items:center;gap:5px;text-decoration:none;background:var(--c-bg-soft);border:1.5px solid #f0c8e0;border-radius:20px;padding:4px 12px;font-size:12px;font-weight:700;color:#d4789a;cursor:pointer;max-width:150px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;-webkit-touch-callout:none;-webkit-user-select:none;user-select:none;">`
    + `🔗 ${site}</a>`
    + `</div>`
  );
}
